<template>
    <v-dialog v-model="dialog" max-width="610" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="py-8 px-11">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <v-form @submit.prevent="handleSubmit(save)">
                    <h2 class="text-center">Edit Team</h2>

                    <ValidationProvider name="Name" rules="required|max:80" v-slot="{ errors }">
                        <v-text-field label="Name"
                                      v-model="team.name"
                                      :loading="loadingRequest"
                                      class="mt-5"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-team'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider name="Teacher" rules="required" v-slot="{ errors }">
                        <v-select :items="teachers"
                                  label="Teacher"
                                  item-text="full_name"
                                  item-value="id"
                                  v-model="team.teacher_id"
                                  :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-teacher'" size="15" class="mr-1"></svg>
                            </template>

                            <template v-slot:append>
                                <svg v-svg="'icon-select'" size="16"></svg>
                            </template>
                        </v-select>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider name="Stage" rules="required_if:Status,0" v-slot="{ errors }">
                        <v-select :items="[{id: null, name:'- Finished -'}, ...stages]"
                                  label="Stage"
                                  item-text="name"
                                  item-value="id"
                                  v-model="team.stage"
                                  :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-stage'" size="15" class="mr-1"></svg>
                            </template>

                            <template v-slot:append>
                                <svg v-svg="'icon-select'" size="16"></svg>
                            </template>
                        </v-select>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider name="Status" rules="required" v-slot="{ errors }">
                        <v-select :items="statuses"
                                  label="Status"
                                  item-text="name"
                                  item-value="id"
                                  v-model="team.status"
                                  :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-study-status'" size="15" class="mr-1"></svg>
                            </template>

                            <template v-slot:append>
                                <svg v-svg="'icon-select'" size="16"></svg>
                            </template>
                        </v-select>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <v-card-actions class="d-flex justify-center mt-6">
                        <v-btn class="green white--text mr-4" type="submit" :loading="loadingSave">Save</v-btn>
                        <v-btn class="transparent green--text ml-4" @click="dialog = false">Close</v-btn>
                    </v-card-actions>
                </v-form>
            </ValidationObserver>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props : ['team_id'],
        data(){
            return {
                dialog: false,
                loadingRequest: false,
                loadingSave: false,
                team: {},
                teachers: [],
                stages: [],
                statuses: [
                    {id: 0, name: 'In Progress'},
                    {id: 1, name: 'Finished'}
                ]
            }
        },

        watch: {
            'dialog' : function (newVal) {
                if(newVal) {
                    this.getTeachers();
                    this.getStages();
                    this.loadingRequest = true;
                    this.$apiAdmin('teams').show(this.team_id).then((res) => {
                        this.team = res.data.team;
                    }).finally(() => {
                        this.loadingRequest = false;
                    })
                }
            }
        },

        methods: {
            save() {
                this.loadingSave = true;
                this.$apiAdmin('teams').update(this.team, this.team_id)
                    .then(() => {
                        this.team = {};
                        this.$refs.form.reset();
                        this.$parent.$emit('getTeams');
                        this.$store.dispatch('alert', {type: 1, message: 'Successfully updated.'});
                    }).catch((err) => {
                    if (err.response.status === 422) console.log(err.response.data);
                }).finally(() => {
                    this.loadingSave = false;
                    this.dialog = false;
                })
            },

            getTeachers(){
                this.$apiAdmin('users').get({params: {all: 1, teachers: 1}})
                    .then((res) => {
                        this.teachers = res.data.users;
                    })
            },

            getStages(){
                this.$apiAdmin('subjects').getFullSubject({params: {all: 1}}).then((res) => {
                    this.stages = res.data.courses;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/components/dialog";
</style>